import axios from 'axios';
import API_CONFIG from '../config/api';

// API基础配置
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || API_CONFIG.BASE_URL;

// 静态资源配置
export const STATIC_CONFIG = {
  // 图片资源基础URL
  IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL || 'https://www.bing-offer.com/storage',
  
  // 是否启用图片baseurl拼接
  ENABLE_IMAGE_BASEURL: process.env.REACT_APP_ENABLE_IMAGE_BASEURL !== 'false',
  
  // 占位头像配置
  AVATAR_CONFIG: {
    service: 'https://ui-avatars.com/api/',
    size: 200,
    background: '1976d2',
    color: 'ffffff',
    format: 'png',
    rounded: true,
    bold: true
  }
};

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加认证token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 统一处理错误
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 未授权，清除token，并触发storage事件通知React组件
      localStorage.removeItem('auth_token');
      
      // 触发自定义事件，通知React组件状态变化
      window.dispatchEvent(new CustomEvent('authTokenCleared'));
    }
    
    // 确保错误对象包含完整的响应信息
    if (error.response?.data) {
      error.responseData = error.response.data;
    }
    
    return Promise.reject(error);
  }
);

// 认证相关API
export const authAPI = {
  // 邮箱密码登录
  login: (credentials) => apiClient.post(API_CONFIG.AUTH.LOGIN, credentials),
  
  // 手机验证码登录
  smsLogin: (data) => apiClient.post(API_CONFIG.AUTH.SMS.LOGIN, data),
  
  // 发送短信验证码
  sendSms: (phone) => apiClient.post(API_CONFIG.AUTH.SMS.SEND, { phone }),
  
  // 邮箱验证码登录
  emailLogin: (data) => apiClient.post('/api/auth/email-login', data),
  
  // 发送邮箱验证码
  sendEmailCode: (email) => apiClient.post('/api/auth/send-email-code', { email }),
  
  // 微信登录相关
  getWechatQRCode: () => apiClient.post(API_CONFIG.AUTH.WECHAT.QR_CODE),
  checkWechatQRStatus: (sceneId) => apiClient.get(`${API_CONFIG.AUTH.WECHAT.QR_STATUS}/${sceneId}`),
  
  // 刷新token
  refreshToken: () => apiClient.post('/api/auth/refresh'),
  
  // 登出
  logout: () => apiClient.post(API_CONFIG.AUTH.LOGOUT),
  
  // 获取用户信息
  getUserInfo: () => apiClient.get('/api/auth/user'),
};

// 导出默认的apiClient
export default apiClient; 